import {
  CHANGE_PASSWORD_URL,
  DELETE_PRODUCT_URL,
  EDIT_PRODUCT_URL,
  FILE_UPLOAD_URL,
  LIST_OF_PRODUCTS_URL,
  LIST_OF_ENQUIRY_URL,
  UPDATE_INQUIRY_URL,
  LOGIN_URL,
  REQUEST_ADD_PRODUCT_URL,
  UPDATE_PASSWORD_URL,
  VERIFY_EMAIL_URL,
  VIEW_PRODUCT_URL,
  ADD_SERVICE_URL,
  LIST_OF_SERVICES_URL,
  VIEW_SERVICE_URL,
  DELETE_SERVICES_URL,
  UPDATE_SERVICE_URL,
  ADD_MEMBERS_URL,
  LIST_OF_MEMBERS_URL,
  VIEW_MEMBERS_URL,
  DELETE_MEMBERS_URL,
  UPDATE_MEMBERS_URL,
} from "API/Routes/Routes";
import { authData, multipartDataWithToken, nonAuthData } from "./services";

export const LOGIN_USER_COMMON = async (data: object) => {
  const response = await nonAuthData.post(LOGIN_URL, data);
  return response?.data;
};

export const REQUEST_VERIFY_EMAIL_COMMON = async (data: object) => {
  const response = await nonAuthData.post(VERIFY_EMAIL_URL, data);
  return response?.data;
};

export const REQUEST_UPDATE_PASSWORD_COMMON = async (data: object) => {
  const response = await nonAuthData.put(UPDATE_PASSWORD_URL, data);
  return response?.data;
};

export const REQUEST_CHANGE_PASSWORD_COMMON = async (data: object) => {
  const response = await authData.put(CHANGE_PASSWORD_URL, data);
  return response?.data;
};


export const API_FETCH_ENQUIRIES = async (data: object) => {
  const response = await authData.post(LIST_OF_ENQUIRY_URL, data);
  return response?.data;
};


export const API_UPDATE_INQUIRY_STATUS= async (id: number, data :any) => {
  const response = await authData.put(`${UPDATE_INQUIRY_URL}${id}`, data);
  return response?.data;
};

export const REQUEST_ADD_PRODUCT_COMMON = async (data: object) => {
  const response = await authData.post(REQUEST_ADD_PRODUCT_URL, data);
  return response?.data;
};


export const REQUEST_FILE_UPLOAD_COMMON = async (data: object) => {
  const response = await multipartDataWithToken.post(FILE_UPLOAD_URL, data);
  return response?.data;
};

export const REQUEST_LIST_OF_PRODUCTS_COMMON = async (data: object) => {
  const response = await authData.post(LIST_OF_PRODUCTS_URL, data);
  return response?.data;
};

export const REQUEST_EDIT_PRODUCT_COMMON = async (id:number,data: any) => {
  const response = await authData.put(`${EDIT_PRODUCT_URL}${id}`, data);
  return response?.data;
};

export const REQUEST_DELETE_PRODUCT_COMMON = async (id:number) => {
  const response = await authData.delete(`${DELETE_PRODUCT_URL}${id}`);
  return response?.data;
};


export const REQUEST_VIEW_PRODUCT_COMMON = async (id:number) => {
  const response = await authData.get(`${VIEW_PRODUCT_URL}${id}`);
  return response?.data;
};
export const REQUEST_ADD_SERVICE_COMMON = async (data: object) => {
  const response = await authData.post(ADD_SERVICE_URL, data);
  return response?.data;
};

export const REQUEST_LIST_OF_SERVICES_COMMON = async (data: object) => {
  const response = await nonAuthData.post(LIST_OF_SERVICES_URL, data);
  return response?.data;
};

export const REQUEST_VIEW_SERVICE_COMMON = async (id:number) => {
  const response = await authData.get(`${VIEW_SERVICE_URL}${id}`);
  return response?.data;
};

export const REQUEST_DELETE_SERVICE_COMMON = async (id: number) => {
  const response = await authData.delete(`${DELETE_SERVICES_URL}${id}`);
  return response?.data;
};

export const REQUEST_UPDATE_SERVICE_COMMON= async (id: number, data :any) => {
  const response = await authData.put(`${UPDATE_SERVICE_URL}${id}`, data);
  return response?.data;
};


export const REQUEST_ADD_MEMBERS_COMMON = async (data: object) => {
  const response = await authData.post(ADD_MEMBERS_URL, data);
  return response?.data;
};

export const REQUEST_LIST_OF_MEMBERS_COMMON = async (data: object) => {
  const response = await authData.post(LIST_OF_MEMBERS_URL, data);
  return response?.data;
};

export const REQUEST_VIEW_MEMBERS_COMMON = async (id:number) => {
  const response = await authData.get(`${VIEW_MEMBERS_URL}${id}`);
  return response?.data;
};

export const REQUEST_DELETE_MEMBERS_COMMON = async (id: number) => {
  const response = await authData.delete(`${DELETE_MEMBERS_URL}${id}`);
  return response?.data;
};

export const REQUEST_UPDATE_MEMBERS_COMMON= async (id: number, data :any) => {
  const response = await authData.put(`${UPDATE_MEMBERS_URL}${id}`, data);
  return response?.data;
};
